module.exports = __webpack_public_path__ + "img/about-us-bg.0dc6c7b0.jpg";